import React from 'react';
import { OpentokSessionValue } from '../../../connection/health';
import { SessionFacts } from '../../../hooks/health/use-session-monitor';
import { Probe } from '../types';
import HealthPanel from '../health-panel';
import CopyValue from '../copy-value';

interface Props {
	probe: Probe<OpentokSessionValue> | undefined;
	facts: SessionFacts; /** From the monitor's own QoS reports, so empty until it is measuring. */
}

/**
 * What the session is, rather than who is in it - how sync provisioned it and
 * what this dashboard's own connection to it landed on.
 *
 * Publishers used to be listed here too, from the roster alone. They are in the
 * table below now, where the roster is joined to the media server's own stream
 * list and the two can be compared.
 */
export default function OpentokPanel({ probe, facts }: Props) {
	return (
		<HealthPanel title='OpenTok session' source='sync' probe={probe}>
			<dl className='health-facts'>
				<dt>Session</dt>
				<dd><CopyValue value={probe?.data?.sessionId ?? ''} mono /></dd>
				<dt>Media region</dt>
				<dd>{probe?.data?.region ?? 'default'}</dd>
				{facts.mediaServer && (
					<>
						<dt>Media server</dt>
						<dd>
							{facts.mediaServer}
							{facts.p2p && ' · p2p'}
							{facts.relayServer && ` · relayed via ${facts.relayServer}`}
						</dd>
					</>
				)}
				{typeof facts.signalingScore === 'number' && (
					<>
						<dt>Signalling quality</dt>
						<dd>{facts.signalingScore}</dd>
					</>
				)}
			</dl>
		</HealthPanel>
	);
}
